module.exports = __webpack_public_path__ + "static/media/Corn0VE.c7c2b70a.png";